import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./system.configuration.proxy";
var SystemConfigurationService = /** @class */ (function () {
    function SystemConfigurationService(systemConfigurationProxy) {
        this.systemConfigurationProxy = systemConfigurationProxy;
    }
    SystemConfigurationService.prototype.getConfigByKey = function (key) {
        return this.cachedSysCfg[key];
    };
    SystemConfigurationService.prototype.getSystemConfiguration = function () {
        var _this = this;
        return this.systemConfigurationProxy.GetSystemConfiguration().pipe(map(function (sysCfg) {
            _this.cachedSysCfg = sysCfg;
            return sysCfg;
        }));
    };
    SystemConfigurationService.prototype.getPreLoginSystemConfiguration = function () {
        var _this = this;
        return this.systemConfigurationProxy.GetPreLoginSystemConfiguration().pipe(map(function (sysCfg) {
            _this.cachedSysCfg = sysCfg;
            return sysCfg;
        }));
    };
    SystemConfigurationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SystemConfigurationService_Factory() { return new SystemConfigurationService(i0.ɵɵinject(i1.SystemConfigurationProxy)); }, token: SystemConfigurationService, providedIn: "root" });
    return SystemConfigurationService;
}());
export { SystemConfigurationService };
